<template>
	<div class="modal fade" ref="modal">
		<MdFormLoad
			ref="smartForm"
			:chForm="chForm"
			@cancelar="close"
			@salvar="save"
			@imprimir="print_contract"
			@enviarEmail=""
		/>
		<!-- <div ref='teste' style='background-color: #fff;'></div> -->
	</div>
</template>
<script>
	import MdFormLoad from '../../models/create-form/components/mdFormLoad.vue';
	import RsModalReadForm from '../../models/create-form/resets/modal-form-load.js';
	import clone from 'js/clone';
	import WBS from 'js/http';
	import toastr from 'toastr';

	export default {
		data() {
			return {
				chForm: clone(RsModalReadForm),
				opened: null,
			};
		},
		components: {
			MdFormLoad,
		},
		methods: {
			print_contract(val) {
				if (this.chForm.settings.printInfo != '') {
					WBS.send(
						'protected-save-smartForm',
						{ cod: this.opened.cod, objeto: val },
						(resp) => {
							let sData = {
								data: {
									os: this.opened,
									form: val,
									doc: this.chForm.settings.printInfo,
								},
								loader: 'ordem_servico',
							};
							WBS.send(
								'protected-custom-replaceDocument',
								sData,
								(resp) => {
									// $(this.$refs.teste).html(resp.data['<dimencionamento>'])

									// console.log(resp)
									let tela_impressao =
										window.open('about:blank');
									console.log(tela_impressao.document);
									tela_impressao.document.write(
										window.atob(resp.data)
									);
									// tela_impressao.window.print();
									// tela_impressao.window.close();
								}
							);
						}
					);
				} else {
					toastr.warning(
						'Entre em contato com o gestor do sistema para que ele defina um template.'
					);
				}
			},
			save(data) {
				WBS.send(
					'protected-save-smartForm',
					{ cod: this.opened.cod, objeto: data },
					(resp) => {
						if (resp.status == 'success' && resp.data == true) {
							toastr.success(
								'Dados complementares salvos com sucesso!'
							);
							$(this.$refs.modal).modal('hide');
							this.$emit('updateTable');
						}
					}
				);
			},
			close() {
				$(this.$refs.modal).modal('hide');
			},
			open(val) {
				this.opened = clone(val);
				this.chForm = clone(RsModalReadForm);
				WBS.send(
					'protected-read-smartForm',
					{ cod: val.forms[0] },
					(resp) => {
						if (
							resp.status == 'success' &&
							resp.data != undefined
						) {
							this.chForm = resp.data;
							$(this.$refs.modal).modal('show');
							this.$refs.smartForm.load(val.objeto);
						} else {
							console.log(resp);
							toastr.error(resp.msgs[0]);
						}
					}
				);
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/supervisao/components/comp.forms.vue